import type { VaultPropertyOption } from './VaultPropertyOption';

export enum VaultPropertyColor {
  BLUE = '#E3EEFB',
  RED = '#FEE9E6',
  PINK = '#FFDEEB',
  GRAPE = '#F3D9FA',
  VIOLET = '#E5DBFF',
  INDIGO = '#DBE4FF',
  CYAN = '#C5F6FA',
  TEAL = '#E1F0E9',
  GREEN = '#D3F9D8',
  LIME = '#EDF9CE',
  YELLOW = '#FFF3BF',
  ORANGE = '#FFE8CC',
}

export type VaultProperty = {
  id: number;
  name: string;
  description: string;
  options: VaultPropertyOption[];
  type: VaultPropertyType;
  color: VaultPropertyColor;
};

export enum VaultPropertyType {
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
}

export type VaultPropertyValue = {
  name: string;
  description: string;
};
